import React from 'react';
import { View, TouchableWithoutFeedback, StyleSheet } from 'react-native';
// import Icons from 'react-native-vector-icons/FontAwesome';
// import Icon from 'react-native-vector-icons/dist/Ionicons';
import { Text, Styles } from './../UI-Components';
// import Timer from "./../Timer";
import moment from 'moment'

import Icon from '@material-ui/core/Icon';
import Lock from '@material-ui/icons/Lock';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Timer from './../timer'


export default ({
    isUserAccessible,
    canUserStart,
    isTestCompleted,
    isTestStarted,
    isTestInAnHour,
    goToScreen,
    testSeriesTestId,
    messageForTest,
    start_date_time,
    checkTestStartTime,
}) => {

    // const [timerCompleted, timerChange] = React.useState(false);
    // console.log(start_date_time, "Asd")
    // console.log((moment(start_date_time) - moment()) / 1000, "ASlaksndlasd")

    return (
        <TouchableWithoutFeedback
            onPress={() => {
                if (!isUserAccessible) return  messageForTest('Please purchase the test');
                if (canUserStart) return goToScreen('/TestTerms', testSeriesTestId);
                if (isTestCompleted) return goToScreen('/ShowResults', testSeriesTestId);
                if(isUserAccessible && !canUserStart && !isTestStarted) return messageForTest('Wait for the test start time')
                    messageForTest('Not available');
            }}

        >
              <View style={{
                ...styles.testStartButton,
                minWidth: 120,
                //  height: 25,
                backgroundColor: Styles.bgDark,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
                justifyContent: 'space-between',
                borderRadius: 10,
                // elevation: 5,
                paddingHorizontal: 12,
                paddingVertical: 8,
                cursor: 'pointer',
                backgroundColor: isTestCompleted ? Styles.successColor : Styles.primaryColor,                
              }}>
                {
                    isTestCompleted 
                    ? 
                        (
                            <View
                                style={isCenter(isUserAccessible)}
                            >                          
                                <Text style={{
                                         fontSize: 12,
                                         color: '#fff',
                                         marginLeft: 5,
                                         fontFamily: Styles.primaryFontFamily,
                                         textTransform: 'uppercase',
                                         fontWeight: '500',
                                }}>Result</Text>
                                {
                                    isUserAccessible
                                    ?
                                    null
                                    : 
                                    // <Icons name={'lock'} size={14} style={styles.icon} color="#fff" /> 
                                    <Lock
                                      style={{
                                        marginLeft: 8,
                                        color: '#fff',
                                        width: 24,
                                        height: 24
                                      }}
                                    />
                                        
                                    
                                    
                                }
                            
                            </View>                       
                        ) 
                    : 
                        isTestStarted
                    ? 
                        (
                            <View
                                style={styles.flexBetween}
                            >

                            <Text style={{
                                     fontSize: 12,
                                     color: '#fff',
                                     marginLeft: 5,
                                     fontFamily: Styles.primaryFontFamily,
                                     textTransform: 'uppercase',
                                     fontWeight: '500',
                                }}
                            >
                                    Start Test
                            </Text>
                            {
                                isUserAccessible
                                ? 
                                // <Icon name={"ios-arrow-forward"} size={14} style={styles.icon} color="#fff" />
                                <KeyboardArrowRightIcon
                                style={{
                                   
                                    color: '#fff',
                                    width: 20,
                                    height: 20,
                                    marginTop: -3
                                  }}
                                />
                                   
                  
                                : 
                                // <Icons name={'lock'} size={14} style={styles.icon} color="#fff" />
                                <Lock
                                style={{
                                    
                                    color: '#fff',
                                    color: '#fff',
                                    width: 20,
                                    height: 20,
                                    marginTop: -3
                                 
                                  }}
                                />
                                  
                            }

                            </View>
                        ) 
                    : 
                    (
                        <View
                            style={isCenter(isUserAccessible)}
                        >
                            {
                                isTestInAnHour
                                ?
                                <>
                                <Timer
                                // digitStyle={{ color: Styles.White, marginLeft: 2 }}
                                timer={(moment(start_date_time) - moment()) / 1000}
                                onSubmit={checkTestStartTime}
                                // inSeconds={true}
                                textStyles={true}
                                testDetails={true}
                                // separatorStyle={{ color: "#fff" }}
                                hours={true}
                             />
                                
                            
                                   {
                                        isUserAccessible
                                        ?
                                        null
                                        :  
                                        <Lock 
                                        style={{
                                            color: '#fff',
                                            color: '#fff',
                                            width: 20,
                                            height: 20,
                                            marginTop: -3
                                            
                                          }}
                                        >lock</Lock>
                                    } 
                                </> 
                                :
                                <>
                                    <Text style={styles.remainingTime}>{moment(start_date_time).fromNow()}</Text>
                                    {
                                        isUserAccessible
                                        ?
                                        null
                                        :  
                                        <Icon 
                                        style={{
                                            
                                            color: '#fff',
                                          
                                          }}
                                        >lock</Icon>
                                    }
                                </>
                            }                        
                        </View>
                    )
                }

              </View>
            </TouchableWithoutFeedback>
    )
}

function isCenter(status) {
    return  {
        flexDirection: 'row',  
        flex: 1, 
        justifyContent: status ? 'center' : 'space-between',
        alignItems: 'center'
    }
}

const styles = StyleSheet.create({
    testStartButton: {
        minWidth: 120,
        //  height: 25,
        backgroundColor: Styles.bgDark,
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'space-between',
        borderRadius: 10,
        // elevation: 5,
        paddingHorizontal: 12,
        paddingVertical: 8,
       
    },
    buttonTitle: {
        fontSize: 12,
        color: '#fff',
        marginLeft: 5,
        fontFamily: Styles.primaryFontFamily,
        textTransform: 'uppercase',
        fontWeight: '500',
        
    },
    flexBetween: {
        flexDirection: 'row', justifyContent:'space-between', alignItems: 'center', flex: 1
    },
    icon: {        
        marginLeft: 8,
        // marginTop: 1,
    },
    remainingTime: {
        color: "#fff", fontFamily: Styles.primaryFontFamily, fontSize: 12
    },
    flexRowCenter: {
        justifyContent: 'center', alignSelf: 'center', flexDirection: 'row'                              
    }

})